const Banner = ({children}) => {
  return (
    <div className="stellco_banner">
      {children}
    </div>
  );
}

export default Banner;